<template>
  <div class="contracts-all">
    <div class="ms-container">
      <div class="filters-bar">
        <contracts-filter />
        <router-link
          v-if="getContractModulePerms('contract_info', 'create')"
          to="/app/contracts/edit"
        >
          <i-button type="success">
            Создать новый проект
          </i-button>
        </router-link>
      </div>
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить список проектов. Повторите, пожалуйста, попытку
        позже
      </div>
      <template v-else-if="contracts.length">
        <lazy-list
          :height="height"
          :page-loading="pageLoading"
          :all-data-loaded="allDataLoaded"
          :fetch-handler="handleReachBottom"
        >
          <contracts-item
            :contract="contract"
            v-for="(contract, i) in contracts"
            :key="contract.id"
            :index="i + 1"
          />
        </lazy-list>
      </template>
      <div class="ms-nodata ms-text" v-else>
        Проекты отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import ContractsItem from '@/components/contracts/list/contracts-item'
import ContractsFilter from '@/components/filters/contracts'
import LazyList from '@/components/parts/lazy-list'
import { getContractsUrl } from '@/config/filters'
import { getActualHeight } from '@/utils'

export default {
  components: {
    InlineLoader,
    ContractsItem,
    ContractsFilter,
    LazyList
  },
  data () {
    return {
      contracts: [],
      loading: false,
      nodata: false,
      allDataLoaded: false,
      limit: 40,
      offset: 0,
      height: 0
    }
  },
  watch: {
    '$store.state.filters.contracts': {
      handler: function () {
        this.offset = 0
        this.allDataLoaded = false
        this.contracts = []
        this.getAllContracts()
      },
      deep: true
    },
    '$store.state.filters.company' () {
      this.offset = 0
      this.allDataLoaded = false
      this.contracts = []
      this.getAllContracts()
    }
  },
  methods: {
    async getAllContracts (noloading) {
      if (this.pageLoading) return

      try {
        if (!noloading) this.loading = true
        this.pageLoading = true
        this.nodata = false
        let url = getContractsUrl(`page/project`, this.$store.state.filters)
        url += `&limit=${this.limit}&offset=${this.offset}`
        const items = await this.$store.dispatch('GET_REQUEST', { url })
        this.contracts = [...this.contracts, ...items]

        if (items.length < this.limit) {
          this.allDataLoaded = true
        }

        this.offset += this.limit
        this.loading = false
        this.pageLoading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.pageLoading = false
        this.nodata = true
      }
    },
    handleReachBottom () {
      return new Promise(async (resolve) => {
        await this.getAllContracts(true)
        resolve()
      })
    },
    changeListHeight () {
      const height = getActualHeight()

      this.height = height - 144
    }
  },
  created () {
    this.changeListHeight()
    this.getAllContracts()
    window.addEventListener('resize', this.changeTableHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.changeTableHeight)
  }
}
</script>

<style></style>
